import samio from "../assets/projects/samio.jpg";
import partfinder from "../assets/projects/partfinder.jpg";
import academia from "../assets/projects/academia.jpg";
import emk from "../assets/projects/emk.jpg";
import elcano from "../assets/projects/elcano.jpg";
import bmb from "../assets/projects/bmb.jpg";

/**
 * Agency portfolio — live client platforms.
 *
 * Descriptions are written from each site's own homepage (read on 23 Jul 2026),
 * in our own words, describing what the platform does. They are DRAFTS: please
 * confirm each one, and especially the role/scope lines, before this ships —
 * a couple carry details worth double-checking (flagged inline).
 *
 * Screenshots live in src/assets/projects and were captured from the live sites.
 * To refresh one, drop a new image at the same path.
 */
export type AgencyProject = {
  name: string;
  /** One line: what the platform does. */
  summary: string;
  /** Short qualifiers — kind of product, market, our role. */
  tags: string[];
  url: string;
  /** Domain shown on the card, without protocol. */
  display: string;
  image: string;
};

export const AGENCY_PROJECTS: AgencyProject[] = [
  {
    name: "Samio Learning",
    summary:
      "An adaptive learning app for children aged 4–12. It reads what a child already knows and adjusts difficulty in real time across reading, maths, writing and time-telling — one curriculum, no boredom.",
    tags: ["Own product", "Mobile app", "Design + build"],
    url: "https://samiolearning.com/",
    display: "samiolearning.com",
    image: samio,
  },
  {
    name: "PartFinder",
    summary:
      "A marketplace app for car parts across Latin America. Workshops post what they need and receive quotes from verified suppliers in minutes — with photos, voice, AI scanning, chat and delivery in one place.",
    tags: ["Marketplace", "LATAM", "Mobile app"],
    url: "https://www.partfinderlatam.com/",
    display: "partfinderlatam.com",
    image: partfinder,
  },
  {
    name: "Academia OnAir",
    summary:
      "An online academy for voice professionals — radio, dubbing, podcasting and presenting — with live training from working broadcasters. Spanish-language, built for a LATAM audience.",
    tags: ["E-learning", "Live courses", "Branding + web"],
    url: "https://www.academiaonair.com/",
    display: "academiaonair.com",
    image: academia,
  },
  {
    name: "Every Mother Knows",
    summary:
      "A platform connecting mothers to flexible, family-friendly jobs and career coaching. We advised on the technical side only — the design and build were not ours.",
    tags: ["Careers platform", "Technical advisory"],
    url: "https://everymotherknows.org/",
    display: "everymotherknows.org",
    image: emk,
  },
  {
    name: "Elcano",
    summary:
      "A navigation app for cruising sailors. Plan smarter routes for the waters you actually sail, follow them from the cockpit, and let the logbook keep itself.",
    tags: ["Navigation app", "Web + product"],
    url: "https://www.elcanonav.com/",
    display: "elcanonav.com",
    image: elcano,
  },
  {
    name: "Building My Business",
    summary:
      "A bilingual guide to starting and running an online business in the Netherlands — registration, GDPR, marketing, shipping, e-commerce and accounting, gathered into one resource.",
    tags: ["Resource site", "Netherlands", "Web + content"],
    url: "https://www.buildingmybusiness.nl/",
    display: "buildingmybusiness.nl",
    image: bmb,
  },
];
